import React, { useState, useEffect } from "react";
import { getCurrentDate, secondsToHHMM, timeToSeconds } from "../../Utilitie";
import { FaEraser, FaUpload } from "react-icons/fa";
import Loading from "../../Extra/Loading";
import { MdInsertChart } from "react-icons/md";
import SuccessMsg from "../../Extra/SuccessMsg";
import FailedMsg from "../../Extra/FailedMsg";
import axios from "axios";

const LongHaulTOUpdate = () => {
  const urlPrefix = process.env.REACT_APP_URL_PREFIX;

  const currentDate = getCurrentDate();

  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(false);
  const [globalDate, setGlobalDate] = useState(currentDate);
  const [show, setShow] = useState(false);

  const [gridData, setGridData] = useState([]);
  const [resultMsg, setResultMsg] = useState(false);

  const [error, setError] = useState(false);
  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        `${urlPrefix}longhaul-takenover?from=${globalDate}&to=${globalDate}`,
      );
      if (response.data.status === "ok") {
        setGridData(response.data.data);
      }
      setLoading(false);
    } catch (error) {
      console.error("Failed to fetch stations:", error);
      setLoading(false);
      setError(true);
    }
  };
  useEffect(() => {
    fetchData();
  }, [globalDate]);
  const columnHead = [
    `A_DATE`,
    `EX`,
    `TRAIN_NO_1`,
    `TRAIN_NO_2`,
    // `TRAIN_NO_3`,
    `ENGINE_NO`,
    `ENGINE_NO_II`,
    // `ENGINE_NO_III`,
    `DEP`,
    `ARRIVAL`,
    `DETENTION`,
    `STATION`,
    `TP_SP`,
    `REMARKS`,
  ];
  // useEffect(() => {
  //   const filtered = (TOData || []).filter(
  //     (row) => row.A_DATE && String(row.A_DATE).slice(0, 10) === globalDate
  //   );
  //   setGridData(filtered);
  // }, [globalDate]);

  // const handleChange = (rowIndex, key, value) => {
  //   const newData = [...gridData];
  //   newData[rowIndex][key] = value;
  //   setGridData(newData);
  // };
  const handleChange = (rowIndex, key, value) => {
    const newData = [...gridData];
    const updatedRow = { ...newData[rowIndex], [key]: value };

    const dep = updatedRow.DEP;
    const arr = updatedRow.ARRIVAL;

    if (key === "DEP" || key === "ARRIVAL") {
      if (dep && arr) {
        updatedRow.DETENTION = Math.abs(arr - dep);
      } else {
        updatedRow.DETENTION = 0;
      }
    }

    newData[rowIndex] = updatedRow;
    setGridData(newData);
  };

  const sendToBackend = async () => {
    const FinalData = gridData.map(({ A_DATE, ...rest }) => rest);
    setLoading(true);
    try {
      const res = await fetch(`${urlPrefix}takenover-update`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(FinalData),
      });
      const data = await res.json();
      setResult(data);
      setShow(true);
      if (data.status === "ok");
    } catch (e) {
      setResult({ status: "failed", message: e.message });
      setShow(true);
    } finally {
      setLoading(false);
    }
  };

  ///////////////////
  const handleDelete = async (rowId) => {
    const confirmed = window.confirm(
      "Are you sure you want to delete this entry?",
    );
    if (!confirmed) return;

    setLoading(true);
    try {
      const response = await fetch(
        `${urlPrefix}delete/longhaul_takenover/${rowId}
    `,
        {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
          },
        },
      );

      const result = await response.json();
      if (
        result.message === "  t_longhaul_handover data  deleted successfully"
      ) {
        setResultMsg({ statusText: "ok", ...result });
        fetchData();
        setShow(true);
      } else if (result.message === "No Data Found with the given ID") {
        setResultMsg(result);
        setShow(true);
      }
      setLoading(false);
      fetchData();
    } catch (err) {
      console.error("Error deleting data:", err);
      setResultMsg({ message: err.message || "Failed to delete data" });
      setShow(true);
      setLoading(false);
    }
  };
  //////////////////////////
  return (
    <div className="text-center mt-12">
      <div className="papaDiv text-start">
        <h4>
          <MdInsertChart />
          LONG HAUL TAKEN OVER
        </h4>
        <h5 className="ps-2">
          Update data in table{" "}
          <b style={{ color: "red" }}>" LONG HAUL TAKEN OVER"</b>
        </h5>
      </div>

      <div className="my-3">
        Select Date:{" "}
        <input
          type="date"
          className="form-control d-inline-block"
          style={{ width: "180px", fontSize: "0.9rem" }}
          value={globalDate}
          max={currentDate}
          onChange={(e) => setGlobalDate(e.target.value)}
        />
      </div>

      <div className="table-responsive">
        <table className="table table-bordered table-striped mb-4 text-center align-middle">
          <thead className="table-dark">
            <tr>
              {columnHead.map((head, index) => (
                <th key={index} style={{ border: "1px solid gray" }}>
                  {head}
                </th>
              ))}
              <th>ACTION</th>
            </tr>
          </thead>

          <tbody>
            {gridData.map((row, rowIndex) => (
              <tr key={rowIndex}>
                {columnHead.map((col, colIndex) => (
                  <td key={colIndex} style={{ border: "1px solid gray" }}>
                    {col === "A_DATE" ? (
                      <input
                        disabled
                        type="date"
                        value={
                          row[col]?.slice(0, 10) || globalDate?.slice(0, 10)
                        }
                        max={currentDate}
                        onChange={(e) =>
                          handleChange(rowIndex, col, e.target.value)
                        }
                      />
                    ) : col === "DETENTION" ? (
                      <input
                        disabled
                        type="number"
                        value={row[col] || ""}
                        onChange={(e) =>
                          handleChange(rowIndex, col, e.target.value)
                        }
                      />
                    ) : col === "DEP" || col === "ARRIVAL" ? (
                      <input
                        type="time"
                        className="form-control"
                        style={{ width: "100px", fontSize: "0.8rem" }}
                        value={
                          typeof row[col] === "number"
                            ? secondsToHHMM(row[col])
                            : row[col] || ""
                        }
                        onChange={(e) =>
                          handleChange(
                            rowIndex,
                            col,
                            timeToSeconds(e.target.value),
                          )
                        }
                      />
                    ) : col === "TP_SP" ? (
                      <select
                        className="form-control"
                        style={{ width: "70px", fontSize: "0.8rem" }}
                        value={row[col] || ""}
                        onChange={(e) =>
                          handleChange(rowIndex, col, e.target.value)
                        }
                      >
                        <option value="" hidden>
                          Select
                        </option>
                        <option value="TP">TP</option>
                        <option value="SP">SP</option>
                      </select>
                    ) : col === "ENGINE_NO" || col === "ENGINE_NO_II" ? (
                      <div className="d-flex gap-1">
                        {["Part 1", "Part 2"].map((label, i) => {
                          const parts = String(row[col] ?? "").split("+");
                          return (
                            <input
                              key={i}
                              type="number"
                              placeholder={label}
                              className="form-control"
                              style={{ width: "75px", fontSize: "0.8rem" }}
                              value={parts[i] || ""}
                              onChange={(e) => {
                                parts[i] = e.target.value.slice(0, 5);
                                const updatedValue = parts
                                  .filter(Boolean)
                                  .join("+");
                                handleChange(rowIndex, col, updatedValue);
                              }}
                            />
                          );
                        })}
                      </div>
                    ) : (
                      <input
                        type="text"
                        className="form-control"
                        value={row[col] || ""}
                        style={{ width: "80px", fontSize: "0.8rem" }}
                        onChange={(e) =>
                          handleChange(rowIndex, col, e.target.value)
                        }
                      />
                    )}
                  </td>
                ))}
                <td style={{ border: "1px solid gray" }}>
                  {" "}
                  <div
                    style={{ width: "50px", padding: "5px" }}
                    className="ms-4 "
                  >
                    <button
                      className="btn btn-danger btn-sm"
                      onClick={() => handleDelete(row.id)}
                      title="Remove Row"
                    >
                      &times;
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="p-3">
        {result?.status === "ok" ? (
          <SuccessMsg
            head="Success"
            message={result?.message}
            show={show}
            setShow={setShow}
          />
        ) : (
          result && (
            <FailedMsg
              head="Failed"
              message={`${result?.message || ""}, ${result?.error || ""}`}
              show={show}
              setShow={setShow}
            />
          )
        )}
      </div>

      <div>
        <button
          className={`m-1 btn btn-sm btn-outline-success ${
            loading ? "disabled" : ""
          }`}
          onClick={sendToBackend}
        >
          <FaUpload /> Upload
        </button>
        {loading && <Loading />}
      </div>
    </div>
  );
};

export default LongHaulTOUpdate;
